export const TeamInvitationRules = {
    "max_invites": 10,
    "default_role": "member"
} as const;